import { CacheHandler } from 'reusable/utils/cache'

export const feedbackCache = {
   documentSummary: new CacheHandler<string[]>({ key: 'feedback:document-summary', cacheLocation: 'localStorage' }),
}
